import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import { IAdvertShort, IRetailerAdvert } from './models/IRetailerAdvert';

export class MarketPlaceService {
    public static $inject = ['http', 'retailerService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
    ) { }

    public getRetailerAdverts() {
        return this.http.get<IRetailerAdvert>(this.retailerService.retailerAdvertsDefault());
    }

    public deleteRetailerAdverts(advertID: number) {
        return this.http.delete<boolean>(this.retailerService.retailerAdverts(advertID));
    }

    public updateRetailerAdverts(advertID: number, model: IAdvertShort) {
        return this.http.put(this.retailerService.retailerAdverts(advertID), model);
    }

    public createAdvert(model: IAdvertShort, image: string) {
        return this.uploadAdvertImage(image)
            .then((imageID) => {
               model.ImageID = imageID;
               return this.createRetailerAdvert(model);
            });
    }

    public updateAdvert(advertID: number, model: IAdvertShort, image: string) {
        return this.uploadAdvertImage(image)
            .then((imageID) => {
                model.ImageID = imageID;
                return this.updateRetailerAdverts(advertID, model);
            });
    }

    public createRetailerAdvert(model: IAdvertShort) {
        return this.http.post<number>(this.retailerService.retailerAdverts(), model);
    }

    public uploadAdvertImage(dataUri: string) {
        return this.http.postFile<number>(this.retailerService.addRetailerAdvertsImage(), dataUri);
    }
}

angular
    .module('naut')
    .service('marketPlaceService', MarketPlaceService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/marketplace/marketplace.service.ts